import React from 'react';
import styles from './Subscribe.module.css'

class Subscribe extends React.Component {

    state = {
        email: "",
    }

    onSubsribe = (event) => {
        event.preventDefault();
        if (this.state.email !== "") {
            this.props.subscribed(this.state.email);
            this.setState({ email: "" })
        }

    }

    handleOnChangeEmail = (event) => {
        this.setState({ email: event.target.value })
    }


    render() {
        return (
            <div className={styles.container}>
                <div className={styles.innerContainer}>
                    <p className={styles.title}>JOIN US!</p>
                    <p className={styles.desc}>Once a week we send unique words and some interesting facts. Sometime we will notify about new lessons and interesting updates.<br/><br/>No spam, no ads, only sweet goodies</p>
                    <form onSubmit={(e) => this.onSubsribe(e)} className={styles.form}>
                        <input
                            className={styles.emailInput}
                            type="email"
                            placeholder="Email Address"
                            name="email"
                            value={this.state.email}
                            onChange={(e) => this.handleOnChangeEmail(e)}></input><br />
                        <input className={styles.submitButton} type="submit" value="SUBSCRIBE"></input>
                    </form>
                </div>
            </div>
        )
    }
}
export default Subscribe;